$(function () {
  "use strict";

  $(".grafich__country")
    .find(".grf-bar")
    .each(function () {
      var h = $(this).attr("data-value");
      var hend = (100 * h) / referece;
      $(this).css("height", hend + "%");
    });

  $(".select-arrow").on("change", function () {
    var url = $(this).val();
    if (url) {
      window.location = url;
    }
    return false;
  });

  //material contact form animation
  $(".form-bills")
    .find(".form-control")
    .each(function () {
      var targetItem = $(this).parent();
      if ($(this).val()) {
        $(targetItem).find("label").css({
          top: "5px",
          fontSize: "14px",
        });
      }
    });
  $(".form-bills")
    .find(".form-control")
    .focus(function () {
      $(this).parent(".input-block").addClass("focus");
      $(this).parent().find("label").animate(
        {
          top: "5px",
          fontSize: "14px",
        },
        300
      );
    });
  $(".form-bills")
    .find(".form-control")
    .blur(function () {
      if ($(this).val().length == 0) {
        $(this).parent(".input-block").removeClass("focus");
        $(this).parent().find("label").animate(
          {
            top: "35px",
            fontSize: "18px",
          },
          300
        );
      }
    });

  $(".form-bills")
    .find(".form-control__date")
    .focus(function () {
      $(this).parent(".input-block__date").addClass("focus");
    });
  $(".form-bills")
    .find(".form-control__date")
    .blur(function () {
      if ($(this).val().length == 0) {
        $(this).parent(".input-block__date").removeClass("focus");
      }
    });

  function setSelectionRange(input, selectionStart, selectionEnd) {
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(selectionStart, selectionEnd);
    } else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd("character", selectionEnd);
      range.moveStart("character", selectionStart);
      range.select();
    }
  }

  function setCaretToPos(input, pos) {
    setSelectionRange(input, pos, pos);
  }

  $("#money").click(function () {
    var inputLength = $("#money").val().length;
    setCaretToPos($("#money")[0], inputLength);
  });

  var options = {
    onKeyPress: function (cep, e, field, options) {
      if (cep.length <= 6) {
        var inputVal = parseFloat(cep);
        jQuery("#money").val(inputVal.toFixed(2));
      }

      // setCaretToPos(jQuery('#money')[0], 4);

      var masks = ["#,##0.00", "0.00"];
      mask = cep == 0 ? masks[1] : masks[0];
      $("#money").mask(mask, options);
    },
    reverse: true,
  };

  document.querySelectorAll('.uploader input[type="file"]').forEach((el) =>
    el.addEventListener("change", (ev) => {
      if (ev.target.files && ev.target.files.length) {
        const text = Array.from(ev.target.files)
          .map((x) => x.name)
          .join(", ");
        el.parentNode.querySelector(".placeholder").innerText = text;
      }
    })
  );

  var num = $(".pagination").find("li").length;
  if (num <= 1) {
    $(".pagination").addClass("d-none");
  }

  $(".menu-mobile").click(function () {
    $(".mobile-mode").toggleClass("d-block");
    $(".mobile-mode").toggleClass("d-none");
    $(".menu-button").toggleClass("d-none");
    $(".close-menu").toggleClass("d-none");
    $(".close-menu").toggleClass("d-block");
  });

  $(".open-filter").click(function () {
    $(this).next(".filter-content").toggleClass("activ");
  });
  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(".filter-content").length &&
      !$(e.target).hasClass("open-filter")
    ) {
      $(".filter-content").removeClass("activ");
    }
  });

  $(".open-col").click(function () {
    $(".fixed-col").toggleClass("activ");
    $(".backgroung-col").toggleClass("d-none");
    $("html").toggleClass("fixed-scroll");
  });

  $(".edit-group").click(function () {
    var id = $(this).attr("data-id");
    var name = $(this).attr("data-name");
    $("#id_group").val(id);
    $("#editgroupname").val(name);
  });

  // Edit menu handler
  $(".edit-menu").click(function () {
    var id = $(this).attr("data-id");
    var parent = $(this).attr("data-parent");
    var order = $(this).attr("data-order");
    var name = $(this).attr("data-name");
    var itemname = $(this).attr("data-itemname");
    var itemlink = $(this).attr("data-itemlink");

    $("#edit_m_id").val(id);
    $("#edit_m_parent").val(parent);
    $("#edit_m_order").val(order);
    $("#edit_m_name").val(name);
    $("#edit_m_item_name").val(itemname);
    $("#edit_m_item_link").val(itemlink);
  });

  $(".edit-page").click(function () {
    var id = $(this).attr("data-id");
    var dataidgroup = $(this).attr("data-id-group");
    var datapage = $(this).attr("data-page");
    $("#id_page").val(id);
    $("select#idgroup option[value=" + dataidgroup + "]").attr(
      "selected",
      "selected"
    );
    $("select#page option[value=" + datapage + "]").attr(
      "selected",
      "selected"
    );
  });

  $(".open-menu").click(function () {
    $(this).next(".submenu").toggle("fast");
    $(this).toggleClass("activ");
  });

  $(".openload").click(function () {
    $(".iconload").removeClass("d-none");
    setTimeout(function () {
      $(".iconload").addClass("d-none");
    }, 5000);
  });

  $(document).ready(function () {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop();
      if (scroll > 100) {
        $(".contas-header").addClass("activ");
      } else {
        $(".contas-header").removeClass("activ");
      }
    });
  });

  $(".icofont-password .icon-eye").click(function () {
    $(this).parent(".icofont-password").toggleClass("activ");
  });

  // Prompt page handlers
  // Toggle favorite
  $(".toggle-favorite").click(function () {
    var btn = $(this);
    var url = btn.data("url");

    $.post(
      url,
      function (response) {
        if (response.success) {
          btn.find("i").toggleClass("text-danger");
        }
      },
      "json"
    );
  });

  // Copy prompt text
  $(".copy-prompt").click(function () {
    var text = $(this).data("text");
    var url = $(this).data("url");

    navigator.clipboard.writeText(text).then(function () {
      // Increment usage count
      $.post(url);
      alert("Prompt copiado para a área de transferência!");
    });
  });

  // Delete prompt
  $(".delete-prompt").click(function () {
    if (!confirm("Tem certeza que deseja deletar este prompt?")) {
      return;
    }

    var url = $(this).data("url");
    var card = $(this).closest(".col-md-6");

    $.post(
      url,
      function (response) {
        if (response.success) {
          card.fadeOut(300, function () {
            $(this).remove();
          });
        } else {
          alert(response.message);
        }
      },
      "json"
    );
  });
});
